<template>
  <div>
    <v-form @submit.prevent="checkForm">
      <!-- Campo Nombre de la Puerta -->
      <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="nombrePuerta"
          label="Nombre de la Puerta de Acceso"
          :error-messages="errores.name ? [errores.name] : []"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>

      <!-- Campo IP de la computadora -->
      <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="ip"
          label="IP de la computadora"
          :error-messages="errores.ip ? [errores.ip] : []"
          outlined
          dense
          required
          :rules="rulesIp"
        ></v-text-field>
      </v-col>

      <!-- Campo Zonas de Seguridad -->
      <v-col cols="12" class="pb-0">
        <v-select
          v-model="accesoSeleccionado"
          :items="areas"
          item-text="nm"
          item-value="id"
          label="Zonas de seguridad"
          :error-messages="errores.areas ? [errores.areas] : []"
          outlined
          dense
          required
        ></v-select>
      </v-col>

      <!-- Botones -->
      <v-col cols="12" class="text-right">
        <v-btn color="green" dark type="submit">Guardar</v-btn>
        <v-btn color="red" dark @click="$emit('toggle', false)">Cancelar</v-btn>
      </v-col>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "PuertasAccesoForm",
  props: ["areas", "dataEdit"],
  data() {
    return {
      nombrePuerta: "",
      accesoSeleccionado: "",
      ip: "",
      id: null,
      errores: {},
      rulesIp: [
        (v) => !!v || "La IP es obligatoria",
        (v) =>
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
            v
          ) || "IP no válida",
      ],
    };
  },
  methods: {
    checkForm() {
      let valido = true;
      this.errores = {};

      if (!this.nombrePuerta) {
        this.errores.name = "El nombre de la puerta de acceso es obligatorio";
        valido = false;
      } else {
        this.errores.name = false;
      }

      if (!this.ip) {
        this.errores.ip = "El ip de la computadora es obligatorio";
        valido = false;
      } else {
        this.errores.ip = false;
      }

      if (!this.accesoSeleccionado) {
        this.errores.areas = "Seleccione algún Área de seguridad";
        valido = false;
      } else {
        this.errores.areas = false;
      }

      if (valido) {
        this.$emit("successData", {
          nombrePuerta: this.nombrePuerta,
          zonaSeguridad: this.accesoSeleccionado.id
            ? this.accesoSeleccionado.id
            : this.accesoSeleccionado,
          ip: this.ip,
          id: this.id ? this.id : "",
          edit: !!this.dataEdit,
        });
      }
    },
  },
  beforeMount() {
    if (this.dataEdit) {
      this.nombrePuerta = this.dataEdit.nm;
      this.id = this.dataEdit.id;
      this.ip = this.dataEdit.ip;
      const area = this.areas.find((area) => area.id === this.dataEdit.zn);
      this.accesoSeleccionado = area;
    }
  },
};
</script>
